import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  getExtraNamefromTicket,
  getFieldValue,
  getVenueNameFromTicket,
  messageResultCode,
  validationModes,
} from "../../utils/verifier.utils";
import { Accordion, Panel } from "react-bootstrap";
import { fetchValidations } from "../../login/api.actions";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import * as moment from "moment";

const ValidationsLog = (props) => {
  const timeZone = JSON.parse(sessionStorage.getItem("timeZone"));
  return (
    <ul>
      {props.validationsLog.map((itemLog, index) => (
        <li key={index}>
          <span className="left-block ">
            {moment(itemLog.scanDate).tz(timeZone).format("DD/MM/YYYY HH:mm:ss")}
          </span>
          <span
            className={
              itemLog.resultCode === 200 || itemLog.resultCode === 203
                ? "success glyphicon glyphicon-stop"
                : "error glyphicon glyphicon-stop"
            }
          />
          &nbsp;
          {itemLog.validationMode === validationModes.override && (
            <span className="icon-own-forced-ticket" />
          )}
          &nbsp;
          {itemLog.numValidatedTickets && (
            <span>{itemLog.numValidatedTickets}</span>
          )}
          {messageResultCode(itemLog.resultCode)}
        </li>
      ))}
    </ul>
  );
};

class TicketInfoLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validationsLog: "",
      events: this.props.events,
    };

    this.handleGetValidations = this.handleGetValidations.bind(this);
  }

  handleGetValidations(ticketId, ticketType) {
    const { dispatch } = this.props;
    this.setState({
      validationsLog: "",
    });

    dispatch(fetchValidations(ticketId, ticketType)).then(({ response }) => {
      //then
      this.setState({
        validationsLog: response,
      });
    });
  }

  render() {
    const { ticketInfo } = this.props;
    const { validationsLog } = this.state;
    const venueName = (ticketInfo) => getVenueNameFromTicket(ticketInfo);
    let group = "";
    let extraId = "ticketExtraId";
    let complementId = "ticketComplementId";

    if (ticketInfo && ticketInfo.ticketGroupId) {
      ticketInfo.ticketId = ticketInfo.ticketGroupId;
      ticketInfo.ticketExtraSet = ticketInfo.ticketExtraGroupSet;
      ticketInfo.ticketComplementSet = ticketInfo.ticketComplementGroupSet;
      extraId = "ticketExtraGroupId";
      complementId = "ticketComplementGroupId";
    }

    return (
      <div className="">
        <div className="modal-header">
          <h4 className="title modal-title">
            <FormattedMessage
              defaultMessage="Tu ticket"
              id="title.your.ticket"
            />
          </h4>
        </div>
        {ticketInfo && ticketInfo.length > 0 ? (
          <div className="ticketInfo">
            <Accordion className="custom-panel">
              {ticketInfo
                .filter((ticket) => !ticket.ticketAsExtra)
                .map((ticketInfo, index) => (
                  <Panel
                    key={`panel-ticketlog-${index}`}
                    onClick={() =>
                      this.handleGetValidations(
                        ticketInfo.ticketGroupId
                          ? ticketInfo.ticketGroupId
                          : ticketInfo.ticketId,
                        ticketInfo.ticketGroupId
                          ? "ticket_main_group"
                          : "ticket_main"
                      )
                    }
                    header={
                      <p
                        className={
                          (!ticketInfo.maxUses && ticketInfo.used >= 1) ||
                          (ticketInfo.maxUses &&
                            ticketInfo.maxUses !== undefined &&
                            ticketInfo.maxUses >= ticketInfo.used)
                            ? "disabled"
                            : ""
                        }
                      >
                        <span className="icon-own-ticketVerifier" />{" "}
                        {venueName(ticketInfo)}&nbsp;
                        <span>
                          (
                          {moment
                            .utc(ticketInfo.validStartDatetime)
                            .format("DD/MM/YYYY")}{" "}
                          -&nbsp; De{" "}
                          {moment
                            .utc(ticketInfo.validStartDatetime)
                            .format("HH:mm")}
                          a{" "}
                          {moment
                            .utc(ticketInfo.validEndDatetime)
                            .format("HH:mm")}
                          )
                        </span>
                        &nbsp;
                        <span>
                          {ticketInfo &&
                          ticketInfo.maxUses &&
                          ticketInfo.maxUses !== ticketInfo.used
                            ? ticketInfo.used + " de " + ticketInfo.maxUses
                            : ""}
                        </span>
                        <span className="pull-right">
                          <span className="glyphicon glyphicon-triangle-bottom" />
                        </span>
                      </p>
                    }
                    eventKey={"pi-0"}
                  >
                    {validationsLog ? (
                      <ValidationsLog validationsLog={validationsLog} />
                    ) : (
                      <div>Loading...</div>
                    )}
                  </Panel>
                ))}

              {ticketInfo.map((ticketInfo) =>
                ticketInfo.ticketExtraSet
                  ? ticketInfo.ticketExtraSet.map((extra, index) => (
                      <Panel
                        key={index}
                        onClick={() =>
                          this.handleGetValidations(
                            getFieldValue(extra, extraId),
                            "ticket_extra" + group
                          )
                        }
                        header={
                          <p
                            className={
                              (!extra.maxUses && extra.used === 1) ||
                              extra.maxUses >= extra.used
                                ? "disabled"
                                : ""
                            }
                          >
                            <span className="icon-own-ticketVerifier" />{" "}
                            {getExtraNamefromTicket(extra.extraId)}
                            &nbsp;
                            <span>
                              {extra.maxUses && extra.maxUses !== extra.used
                                ? extra.used + " de " + extra.maxUses
                                : ""}
                            </span>
                            <span className="pull-right">
                              <span className="glyphicon glyphicon-triangle-bottom" />
                            </span>
                          </p>
                        }
                        eventKey={"xtra-" + index}
                      >
                        {validationsLog ? (
                          <ValidationsLog validationsLog={validationsLog} />
                        ) : (
                          <div>Loading...</div>
                        )}
                      </Panel>
                    ))
                  : ""
              )}

              {ticketInfo.map((ticketInfo) =>
                ticketInfo.ticketComplementSet
                  ? ticketInfo.ticketComplementSet.map((complement, index) => (
                      <Panel
                        key={index}
                        onClick={() =>
                          this.handleGetValidations(
                            getFieldValue(complement, complementId),
                            "ticket_complement" + group
                          )
                        }
                        header={
                          <p
                            className={
                              (!complement.maxUses && complement.used === 1) ||
                              complement.maxUses === complement.used
                                ? "disabled"
                                : ""
                            }
                          >
                            <span className="icon-own-ticketVerifier" />{" "}
                            {getVenueNameFromTicket(complement)}
                            &nbsp;
                            <span>
                              {complement.maxUses &&
                              complement.maxUses !== complement.used
                                ? complement.used + " de " + complement.maxUses
                                : ""}
                            </span>
                            <span className="pull-right">
                              <span className="glyphicon glyphicon-triangle-bottom" />
                            </span>
                          </p>
                        }
                        eventKey={"complement-" + index}
                      >
                        {validationsLog ? (
                          <ValidationsLog validationsLog={validationsLog} />
                        ) : (
                          <div>Loading...</div>
                        )}
                      </Panel>
                    ))
                  : ""
              )}
            </Accordion>
          </div>
        ) : (
          <div>Loading...</div>
        )}
      </div>
    );
  }
}

TicketInfoLogs.PropTypes = {
  ticketInfo: PropTypes.array.isRequired,
  validationLogs: PropTypes.array.isRequired,
};

export default connect()(TicketInfoLogs);
